import React, { FunctionComponent, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import Form from "@rjsf/react-bootstrap";
import validator from "@rjsf/validator-ajv8";

import Limit from "../../models/limit/Limit";
import { BackButton } from "../common/button/Buttons";
import { ContentLayout } from "../common/Layout";
import { useLimit } from "../../hooks/useLimit";
import FirebaseService from "../../actions/firebase/FirebaseActions";
import { useAuthentication } from "../../hooks/useAuthentication";
import { updateLimitEditorSchema } from "./UpdateLimitEditorSchema";
import { trackEvent } from "../../helper/analytics";
import { useUserIdParam } from "../../hooks/useUserIdParam";
import { useLimitIdParam } from "../../hooks/useLimitIdParam";
import { LIMIT_FORM_ID } from "./limitEditorForm";

interface Props {
  isAuthenticated: boolean;
}
const UpdateLimitEditor: FunctionComponent<Props> = ({ isAuthenticated }) => {
  const userId = useUserIdParam();
  const limitId = useLimitIdParam();

  const navigate = useNavigate();
  const [isSaving, setSaving] = useState(false);
  const [limit, limitLoading, limitError] = useLimit(userId, limitId);
  useAuthentication(isAuthenticated);

  const saveLimit = (formData: unknown): void => {
    const { limit: formLimit, price: formPrice } = formData as { limit: number; price: number };
    const limit: Partial<Limit> = {
      id: limitId,
      limit: formLimit,
      price: formPrice || 0
    };

    setSaving(true);
    FirebaseService.updateLimit(userId, limit)
      .then(() => {
        toast.success("Die Änderungen wurden gespeichert");
        navigate(`/user/${userId}/limits`);
      })
      .catch((reason) => {
        console.log(reason);
        toast.error(
          "Es ist ein Fehler beim Speichern der Daten aufgetreten. Bitte laden Sie die Applikation erneut und versuchen Sie es noch einmal."
        );
      })
      .finally(() => {
        setSaving(false);
        trackEvent("update-limit");
      });
  };
  if (limitLoading || !limit) return <p>Daten werden geladen ...</p>;
  else if (limitError) return <p>Fehler beim Laden der Daten</p>;
  else {
    return (
      <ContentLayout
        title={limit.property}
        siteTitle={"Spielgruppe Online - Angebot editieren"}
        subtitle={`${limit.taken}/${limit.limit} Plätze belegt`}
        maxWidth={740}>
        <div className="editor-toolbar">
          <BackButton to={`/user/${userId}/limits`} />
          <button
            type="submit"
            form={LIMIT_FORM_ID}
            disabled={isSaving}
            className="btn btn-primary editor-toolbar__save">
            Speichern
          </button>
        </div>
        <section className="panel">
          <div className="panel__body">
            <Form
              id={LIMIT_FORM_ID}
              validator={validator}
              formData={limit}
              schema={updateLimitEditorSchema}
              onSubmit={(e) => saveLimit(e.formData)}>
              <button type="submit" disabled={isSaving} className="btn btn-primary">
                Speichern
              </button>
            </Form>
          </div>
        </section>
      </ContentLayout>
    );
  }
};

export default UpdateLimitEditor;
